$(function () {
 var $body = $('.site-header__logo');
 $(this).scroll(function() { 
   var topOffset =  $('#shopify-section-footer').offset().top;
   var navTypeAOffsetTop = parseInt(topOffset) - 10000;
   if($(this).scrollTop() > navTypeAOffsetTop) {
     $body.addClass('is-fixed');
   } else {
     $body.removeClass('is-fixed');
   }
 });
});